import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  CHECKBOX_LABEL_VARIANT_BOLD,
  Checkbox,
  Flex,
  FormElement,
} from 'mailup-web-components'

import { modalSubscribeToggleFieldCallback } from 'Pages/RecipientsList/recoil/callbacks/modalSubscribe'
import { modalSubscribeState } from 'Pages/RecipientsList/recoil/state/modalSubscribe'

const InputChannels: FC = () => {
  const intl = useIntl()

  const { channelEmail, channelSMS } = useRecoilValue(modalSubscribeState)

  const toggle = useRecoilCallback(modalSubscribeToggleFieldCallback, [])

  const handleToggleField = (f: 'channelEmail' | 'channelSMS') => (): void => {
    void toggle(f)
  }

  return (
    <FormElement
      required
      label={intl.formatMessage({
        id: 'Load.RecipientsList.ModalSubscribeSelectChannels',
      })}
    >
      <Flex flexDirection="column" gap="16px" margin="16px 0 0 0">
        <Checkbox
          value="email"
          checked={channelEmail}
          onChange={handleToggleField('channelEmail')}
          label={intl.formatMessage({
            id: 'Load.RecipientsList.ModalSubscribeChannelEmail',
          })}
          labelVariant={CHECKBOX_LABEL_VARIANT_BOLD}
          data-mu-test="channel-email"
        />
        <Checkbox
          value="sms"
          checked={channelSMS}
          onChange={handleToggleField('channelSMS')}
          label={intl.formatMessage({
            id: 'Load.RecipientsList.ModalSubscribeChannelSMS',
          })}
          labelVariant={CHECKBOX_LABEL_VARIANT_BOLD}
          data-mu-test="channel-sms"
        />
      </Flex>
    </FormElement>
  )
}

export default InputChannels
